module.exports = __webpack_public_path__ + "img/search.143bc857.svg";